import React, {Component} from "react"
import styled from "styled-components"

import Card from "@irati/ui/src/Layout/Card"
import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"
import {Body, H4, H6} from "@irati/ui/src/Typography"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"

import EnabledDisabledLabel from "./EnabledDisabledLabel"

const FlexItem = styled.div`
  flex-grow: 1;
  width: 33%;
  ${({theme}) => theme.mediaQueries.maxWidthMedia.desktop`
    width: unset;
    flex-grow: unset;
  `}
`

interface Props {
  enabled: boolean,
  title: string,
  text: string,
  logos: any[],
  marginRight?: boolean,
  marginLeft?: boolean,
  load?: Promise<any> | null,
  onClick: () => void
}

class IntegrationCard extends Component<Props> {
  render() {
    const {enabled, title, text, logos, marginRight, marginLeft, load, onClick, formatMessage} = this.props
    const andMore = "admin.containers.integrations.card.andMore"
    return (
      <Card
        marginRight={marginRight ? 2 : null}
        marginLeft={marginLeft ? 2 : null}>
        <Flex justifyContent="flex-end" marginBottom={1}>
          <EnabledDisabledLabel enabled={enabled} />
        </Flex>
        <H4 marginBottom={1}>{formatMessage({id: title})}</H4>
        <Body marginBottom={3}>{formatMessage({id: text})}</Body>
        {logos.length > 0 &&
          <Flex justifyContent="space-around" wrap="wrap" gap="10px 0px">
            {logos.map((item, k)=>
              <FlexItem key={k}>
                {React.cloneElement(item)}
              </FlexItem>
            )}
            <FlexItem>
              <H6>{formatMessage({id: andMore})}</H6>
            </FlexItem>
          </Flex>
        }
        <Button small primary marginTop={2} onClick={onClick} load={load}>
          <FormattedMessage id="admin.containers.integrations.startIntegration.button" />
        </Button>
      </Card>
    )
  }
}

export default injectIntl(IntegrationCard)
